<app-programtitle title="Day of the week"></app-programtitle>
<p> Write a program to display the day of the week.</p>

<p>Python has 3 logical operators. 'and', 'or', 'not'. These operators are used to combine the multiple conditions.</p>

<app-editor code="{{program}}"> </app-editor>